import LoginForm from "../app/auth/LoginForm";
import Flex from "../core/components/Flex";
import { Card } from 'antd';
import {isMobile} from "react-device-detect";
import { Branding } from "../core/service/branding-service";
import "./login.css";

/**
 * Giriş ekranı — beyaz etiket:
 *   kartın içinde, formun üstünde KİRACININ logosu (şeffaf değilse marka ayarındaki renk kutusunda),
 *   arka plan kiracıya ait (yüklemediyse bizim varsayılanımız),
 *   kartın altında ÜRÜN imzası: RIS · eCloudPACS logosu + kuantumbulut.com + telif.
 *   İmza kodda koşulsuzdur; beyaz etiket ayarıyla kaldırılamaz.
 */
export default function LoginPage()
{
    const logo = Branding.asset('loginLogo');
    const background = Branding.asset('loginBackground');
    const logoBackground = Branding.logoBackground('loginLogo');

    return (
        <Flex
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            style={{
                minHeight: '100vh',
                backgroundColor: 'var(--bg)',
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${background})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: isMobile ? '16px' : '24px',
            }}
        >
            <Card
                style={{
                    width: isMobile ? '100%' : 500,
                    maxWidth: 500,
                }}
                styles={{
                    body: { padding: isMobile ? 16 : 24 }
                }}
            >
                <div className="login-logo">
                    <span
                        className={`login-logo-box ${logoBackground ? 'has-bg' : ''}`}
                        style={logoBackground ? { background: logoBackground } : undefined}
                    >
                        <img src={logo} alt={Branding.displayName() || 'Logo'} />
                    </span>
                </div>

                <LoginForm />

                <div className="login-company">
                    {/* ürün imzası: RIS logosu (açık zemin varyantı — kart beyaz) + site */}
                    <a
                        className="login-company-row"
                        href="https://kuantumbulut.com"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <img src="/logo-ris-light.svg" alt="RIS · eCloudPACS" className="login-company-product" />
                        <span className="login-company-site">kuantumbulut.com</span>
                    </a>

                    <div className="login-company-copy">
                        © {new Date().getFullYear()} Kuantum Bulut Bilişim ve Yazılım A.Ş.
                    </div>
                </div>
            </Card>
        </Flex>
    )
}
